/**
 * @module router/cuenta-medica
 * @description Rutas del módulo Cuenta Médica: transacciones y liquidaciones
 */
export default [
  {
    path: "/cuenta-medica",
    component: () =>
      import(
        /* webpackChunkName: "cuenta-medica" */ "@/components/claims/CuentaMedicaLayout.vue"
      ),
    children: [
      {
        path: "",
        redirect: { name: "service-record-list" },
      },
      {
        path: "transacciones",
        name: "service-record-list",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/ServiceRecordList.vue"
          ),
      },
      {
        path: "liquidaciones",
        name: "liquidation-list",
        component: () =>
          import(
            /* webpackChunkName: "cuenta-medica" */ "@/components/claims/LiquidationList.vue"
          ),
      },
    ],
  },
];
